import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

// Swiper の CSS 読み込み
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.swiper = new Swiper(this.containerTarget, {
      modules: [Navigation, Pagination],
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    })
  }
}